import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope, faUser } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import "animate.css";

export default function Contact() {
  const buttonStyle = {
    animationIterationCount: "15",
  };

  const [Companyname, setName] = useState("");
  const [Fullname, setFullname] = useState("");
  const [Email, setEmail] = useState("");
  const [Message, setMessage] = useState("");
  const [Phone, setPhone] = useState("");
  const [custom, setcustom] = useState("");
  const [ui, setui] = useState("");
  const [consulting, setconsulting] = useState("");
  const [refferal, setrefferal] = useState("");
  const [blog, setblog] = useState("");
  const [facebook, setfacebook] = useState("");
  const [yelp, setyelp] = useState("");
  const [twitter, settwitter] = useState("");
  const [Other, setother] = useState("");
  const [LinkedIn, setlinkedIn] = useState("");
  const [Google, setGoogle] = useState("");
  const [googlead, setgooglead] = useState("");
  const [Meetup, setMeetup] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    try {
      await axios.post("https://formspree.io/f/meqwlroz", formData);
      // alert("Form submitted successfully");
      const notify = () => toast("Your form has been submitted sucessfully! ");
      // setName("");
      // setFullname("");
      // setEmail("");
      // setMessage("");
      // setPhone("");
      // setcustom("");
      // setui("");
      // setconsulting("");
      // setGoogle("");
      // setgooglead("");
      // setGoogle("");
      // setMeetup("");
      // setblog("");
      // setrefferal("");
      // setyelp("");
      // settwitter("");
      // setother("");
      // setlinkedIn("");
      // setfacebook("");

      notify();
    } catch (error) {
      toast("Your form has not been submitted check the inputs  ");
    }
  };
  return (
    <div>
      <ToastContainer position="top-center" theme="light" />
      <div className="fd" id="contact">
        <div className=" flex flex-row items-center justify-center ">
          <h1 class="font-bold leading-tight text-1xl mt-0 mb-2 text-gray-100 ">
            Let's have a talk
          </h1>
        </div>
        <div className="text-center">
          <h6 className="font-serif font-bold text-green-500 mt-1 mb-2">
            We would love to hear about your project.
          </h6>
          <p className="font-sans font-bold text-gray-200 mb-4 text-sm  animate-pulse">
            Our engagements begin at a minimum of{" "}
            <span className="text-green-500">$299</span>{" "}
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className=" flex justify-center ">
            <div>
              <div class="relative mb-3 xl:w-96">
                <FontAwesomeIcon
                  icon={faBriefcase}
                  className="flex flex-col"
                  color="white"
                  height="50px"
                  width="50px"
                />

                <input
                  type="text"
                  class="border peer m-0 block h-[58px] w-full rounded bg-transparent bg-clip-padding py-4 px-3 text-base font-normal leading-tight text-gray-200 ease-in-out placeholder:text-transparent focus:border-primary focus:bg-white focus:pt-[1.625rem] focus:pb-[0.625rem] focus:text-gray-200 focus:shadow-te-primary focus:outline-none [&:not(:placeholder-shown)]:pt-[1.625rem] [&:not(:placeholder-shown)]:pb-[0.625rem]"
                  id="floatingCompanyname"
                  required
                  placeholder="Companyname"
                  name="Companyname"
                  value={Companyname}
                  onChange={(e) => setName(e.target.value)}
                />
                <label
                  for="floatingCompanyname"
                  class="pointer-events-none absolute top-0 left-0 origin-[0_0] py-4 px-3 text-gray-200 transition-[opacity,_transform] duration-100 ease-in-out peer-focus:translate-x-[0.15rem] peer-focus:-translate-y-2 peer-focus:scale-[0.85] peer-focus:opacity-[0.65] peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:scale-[0.85] peer-[:not(:placeholder-shown)]:opacity-[0.65] motion-reduce:transition-none "
                >
                  Company name
                </label>
              </div>

              <div class="relative mb-3 xl:w-96">
                <FontAwesomeIcon
                  className="flex flex-col"
                  icon={faUser}
                  color="white"
                  height="50px"
                  width="50px"
                />
                <input
                  type="text"
                  class="border  peer m-0 block h-[58px] w-full rounded bg-transparent bg-clip-padding py-4 px-3 text-base font-normal leading-tight text-gray-200 ease-in-out placeholder:text-transparent focus:border-primary focus:bg-white focus:pt-[1.625rem] focus:pb-[0.625rem] focus:text-gray-200 focus:shadow-te-primary focus:outline-none [&:not(:placeholder-shown)]:pt-[1.625rem] [&:not(:placeholder-shown)]:pb-[0.625rem]"
                  id="floatingFullname"
                  placeholder="Full name"
                  name="Fullname"
                  required
                  value={Fullname}
                  onChange={(e) => setFullname(e.target.value)}
                />
                <label
                  for="floatingFullname"
                  class="pointer-events-none absolute top-0 left-0 origin-[0_0] py-4 px-3 text-gray-200 transition-[opacity,_transform] duration-100 ease-in-out peer-focus:translate-x-[0.15rem] peer-focus:-translate-y-2 peer-focus:scale-[0.85] peer-focus:opacity-[0.65] peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:scale-[0.85] peer-[:not(:placeholder-shown)]:opacity-[0.65] motion-reduce:transition-none "
                >
                  Full name
                </label>
              </div>
              <div class=" relative mb-3 mt-2 xl:w-96">
                <FontAwesomeIcon
                  className="flex flex-col"
                  icon={faEnvelope}
                  color="white"
                  height="50px"
                  width="50px"
                />
                <input
                  type="email"
                  class="border border peer m-0 block h-[58px] w-full rounded bg-transparent bg-clip-padding py-4 px-3 text-base font-normal leading-tight text-gray-200 ease-in-out placeholder:text-transparent focus:border-primary focus:bg-white focus:pt-[1.625rem] focus:pb-[0.625rem] focus:text-gray-200 focus:shadow-te-primary focus:outline-none [&:not(:placeholder-shown)]:pt-[1.625rem] [&:not(:placeholder-shown)]:pb-[0.625rem]"
                  id="floatingInput"
                  placeholder="name@example.com"
                  required
                  name="Email"
                  value={Email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <label
                  for="floatingInput"
                  class="pointer-events-none absolute top-0 left-0 origin-[0_0] py-4 px-3 text-gray-200 transition-[opacity,_transform] duration-100 ease-in-out peer-focus:translate-x-[0.15rem] peer-focus:-translate-y-2 peer-focus:scale-[0.85] peer-focus:opacity-[0.65] peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:scale-[0.85] peer-[:not(:placeholder-shown)]:opacity-[0.65] motion-reduce:transition-none "
                >
                  Email address
                </label>
              </div>
              <div class=" relative mb-3 mt-2 xl:w-96">
                <FontAwesomeIcon
                  className="flex flex-col"
                  icon={faPhone}
                  color="white"
                  height="80px"
                  width="50px"
                />
                <input
                  type="phone"
                  class="border border peer m-0 block h-[58px] w-full rounded bg-transparent bg-clip-padding py-4 px-3 text-base font-normal leading-tight text-gray-200 ease-in-out placeholder:text-transparent focus:border-primary focus:bg-white focus:pt-[1.625rem] focus:pb-[0.625rem] focus:text-gray-200 focus:shadow-te-primary focus:outline-none [&:not(:placeholder-shown)]:pt-[1.625rem] [&:not(:placeholder-shown)]:pb-[0.625rem]"
                  id="floatingphone"
                  placeholder="+923000000000"
                  name="Phone"
                  required
                  value={Phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
                <label
                  for="floatingphone"
                  class="pointer-events-none absolute top-0 left-0 origin-[0_0] py-4 px-3 text-gray-200 transition-[opacity,_transform] duration-100 ease-in-out peer-focus:translate-x-[0.15rem] peer-focus:-translate-y-2 peer-focus:scale-[0.85] peer-focus:opacity-[0.65] peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:scale-[0.85] peer-[:not(:placeholder-shown)]:opacity-[0.65] motion-reduce:transition-none "
                >
                  Contact Number
                </label>
              </div>
              <div class=" relative mb-3 mt-2 xl:w-96">
                <textarea
                  class="border border-green-500 text-gray-200 peer block min-h-[auto] w-full rounded bg-transparent py-[0.32rem] px-3 leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none [&:not([data-te-input-placeholder-active])]:placeholder:opacity-0"
                  id="exampleFormControlTextarea1"
                  rows="4"
                  placeholder="Your message"
                  name="Message"
                  value={Message}
                  required
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
                <label
                  for="exampleFormControlTextarea1"
                  class="pointer-events-none absolute top-0 left-3 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.1] text-gray-200 transition-all duration-200 ease-out peer-focus:-translate-y-[0.9rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.2] motion-reduce:transition-none text-gray-200 "
                >
                  Project details
                </label>
              </div>

              <label
                for="floatingFullname"
                class="block text-gray-200 font-bold"
              >
                Project type
              </label>
              <div class="w-full xl:w-96 btn-group border border-green-500 rounded-sm overflow-hidden flex mt-2 ">
                <input
                  type="radio"
                  class="btn-check"
                  name="custom"
                  value={custom}
                  onChange={(e) => setcustom(e.target.value)}
                  id="option1"
                  autocomplete="off"
                />
                <label
                  class="btn btn-outline-blue hover:bg-blue-500 text-white focus:outline-none focus:shadow-outline-blue active:bg-blue-600"
                  for="option1"
                >
                  Custom Software
                </label>

                <input
                  type="radio"
                  class="btn-check"
                  name="ui"
                  value={ui}
                  onChange={(e) => setui(e.target.value)}
                  id="option2"
                  autocomplete="off"
                />
                <label
                  class="btn btn-outline-blue hover:bg-blue-500 text-white focus:outline-none focus:shadow-outline-blue active:bg-blue-600"
                  for="option2"
                >
                  UI/UX
                </label>

                <input
                  type="radio"
                  class="btn-check"
                  name="consulting"
                  value={consulting}
                  onChange={(e) => setconsulting(e.target.value)}
                  id="option3"
                  autocomplete="off"
                />
                <label
                  class="btn btn-outline-blue hover:bg-blue-500 text-white focus:outline-none focus:shadow-outline-blue active:bg-blue-600"
                  for="option3"
                >
                  Consulting
                </label>
              </div>

              <label
                for="floatinghear"
                class="block text-gray-200 font-bold mt-1"
              >
                How did you hear about us?
              </label>
              <div className="w-full xl:w-96">
                <select
                  required
                  className="border border-gray-200 text-gray-200 py-2 px-3 bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent block w-full"
                >
                  <option value="" hidden selected>
                    Select your option
                  </option>
                  <option
                    onChange={(e) => setrefferal(e.target.value)}
                    value={refferal}
                  >
                    Referral
                  </option>
                  <option
                    onChange={(e) => setMeetup(e.target.value)}
                    value={Meetup}
                  >
                    From a Meetup
                  </option>
                  <option
                    onChange={(e) => setGoogle(e.target.value)}
                    value={Google}
                  >
                    Google Search
                  </option>
                  <option
                    onChange={(e) => setgooglead(e.target.value)}
                    value={googlead}
                  >
                    Google Ad
                  </option>
                  <option
                    onChange={(e) => setfacebook(e.target.value)}
                    value={facebook}
                  >
                    Facebook
                  </option>
                  <option
                    onChange={(e) => setyelp(e.target.value)}
                    value={yelp}
                  >
                    Yelp
                  </option>
                  <option
                    onChange={(e) => setrefferal(e.target.value)}
                    value={blog}
                  >
                    Blog Post
                  </option>
                  <option
                    onChange={(e) => setlinkedIn(e.target.value)}
                    value={LinkedIn}
                  >
                    LinkedIn
                  </option>
                  <option
                    onChange={(e) => settwitter(e.target.value)}
                    value={twitter}
                  >
                    Twitter
                  </option>
                  <option
                    onChange={(e) => setother(e.target.value)}
                    value={Other}
                  >
                    Other
                  </option>
                </select>
              </div>

              <div className="flex flex-col items-center mt-3">
                <button
                  className="animate__animated animate__flash w-40 h-10 bg-gray-600 hover:bg-green-500 rounded-md text-white"
                  style={buttonStyle}
                  type="submit"
                >
                  Submit
                </button>

                <br></br>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
